// docs: https://github.com/altostra/type-validations#readme
import { anyOf, arrayOf, objectOf } from "@altostra/type-validations";
import { string, number } from "@altostra/type-validations/lib/primitives";

export const isMessagePrioritizationRulesValidationResult = objectOf({
  errors: arrayOf(
    objectOf({
      code: string,
      path: arrayOf(anyOf(string, number)),
    })
  ),
});
